import React, {Component} from 'react';
import Title from './Title';
import Fade from 'react-reveal/Fade';
import Slider from 'react-slick';

class Team extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }

    next() {
        this.slider.slickNext();
    }

    previous() {
        this.slider.slickPrev();
    }

    render() {
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 7000,
            slidesToShow: 1,
            slidesToScroll: 1,
        };
        return (
            <div className="testimonial_area_two" id="team">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <Title btitle="GODEYE" stitle="The Team behind SecAI"/>
                            <Fade bottom cascade>
                                <div className="wow fadeInUp" data-wow-delay="0.3s">
                                    <p>It was an amazing journey, starting with just a secure AI sharing system, to the refining it to support generic code, then expanding to multiple language support, and finally ariving at SecAI. We hope to continue this journey to make it easier to deploy projects, share them and worry less!<br/> It was great building this at InOut 7.0. We have just taken our first leap to the limitless skies that we can soar to. </p>
                                </div>
                                <div className="slider_nav">
                                    <i className="arrow_carrot-left_alt2 prev" onClick={this.previous}></i>
                                    <i className="arrow_carrot-right_alt2 next" onClick={this.next}></i>
                                </div>
                            </Fade>
                        </div>
                        <div className="col-lg-6">
                            <div className="testimonial_slider_info">
                                <div className="stratup_testimonial_info d-flex align-items-center">
                                    <Slider ref={c => (this.slider = c)}
                                            className="testimonial_slider_four" {...settings}>
                                        <div className="item">
                                            <div className="author_img">
                                                <img src={require('../image/co-founder-images/co-founder-1.jpg')} alt="co-founder-img"/>
                                            </div>
                                            <p></p>
                                            <h5>Aditya Sihmar</h5>
                                            <h6>Co-Founder</h6>
                                            <h6 className="company">SecAI</h6>
                                            <br />
                                            <a href="https://www.linkedin.com/in/aditya-sihmar/"><span style={{"fontSize": "2.5em", "color": "#E3F0F5"}}><i className="fab fa-linkedin"></i></span></a>
                                        </div>
                                        <div className="item">
                                            <div className="author_img">
                                                <img src={require('../image/co-founder-images/co-founder-2.jpg')} alt="co-founder-img"/>
                                            </div>
                                            <p></p>
                                            <h5>Aayush Kumar</h5>
                                            <h6>Co-Founder</h6>
                                            <h6 className="company">SecAI</h6>
                                            <br />
                                            <a href="https://www.linkedin.com/in/ayush1804/"><span style={{"fontSize": "2.5em", "color": "#E3F0F5"}}><i className="fab fa-linkedin"></i></span></a>
                                        </div>
                                        <div className="item">
                                            <div className="author_img">
                                                <img src={require('../image/co-founder-images/co-founder-3.jpg')} alt="co-founder-img"/>
                                            </div>
                                            <p></p>
                                            <h5>Nikhil Kumar</h5>
                                            <h6>Co-Founder</h6>
                                            <h6 className="company">SecAI</h6>
                                            <br />
                                            <a href="https://www.linkedin.com/in/nik-99/"><span style={{"fontSize": "2.5em", "color": "#E3F0F5"}}><i className="fab fa-linkedin"></i></span></a>
                                        </div>
                                        <div className="item">
                                            <div className="author_img">
                                                <img src={require('../image/co-founder-images/co-founder-4.jpg')} alt="co-founder-img"/>
                                            </div>
                                            <p></p>
                                            <h5>Sparsh Kesari</h5>
                                            <h6>Co-Founder</h6>
                                            <h6 className="company">SecAI</h6>
                                            <br />
                                            <a href="https://www.linkedin.com/in/sparshk98/"><span style={{"fontSize": "2.5em", "color": "#E3F0F5"}}><i className="fab fa-linkedin"></i></span></a>
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Team;
